import type { RouteObject } from "react-router";
import { ProductList } from "./ProductList";
import { ProductAvailabilityList } from "./ProductAvailabilityList";

/** The /product route: the product list. */
export const productRoute: RouteObject = {
  path: "product",
  element: <ProductList />,
};

/** The /availability route: Cin7 product availability. */
export const availabilityRoute: RouteObject = {
  path: "availability",
  element: <ProductAvailabilityList />,
};
